<template>

    <Page>
        <div class="max-h-[70%] !min-w-[90%] bg-white rounded-lg overflow-hidden shadow-2xl ring-[3px] ring-white p-1">
            <div class="ring ring-gray-900 rounded-md">
                <Image 
                    src="/History/we-are-here.jpg"
                    class="h-full object-cover mx-auto overflow-hidden" 
                    image-class="rounded-md"
                />
            </div>
        </div>
        <KeyMessage>
            Built, tested, established in market &amp; validated by customers
        </KeyMessage>
    </Page>

</template>